import React from 'react';
import PropTypes from 'prop-types';
import { ConnectionOption, LogoOption, ColorOption, LanguageOption } from '../EditorOption/';

const getOptionsValue = (options, value) =>
  options.find(opt => opt[0] === value)[1];

const EditorWeb = ({ onOptionChange, options, logos, defaultColor }) =>
  <ol className="code-container">
    <li className="line-row">
      <span>{'var lock = new Auth0Lock(cid, domain, {'}</span>
    </li>
    <li className="line-row indent-1">
      <span>{'allowedConnections: '}</span>
      <ConnectionOption
        value={getOptionsValue(options, 'allowedConnections')}
        onChange={onOptionChange}
      />
    </li>
    <li className="line-row indent-1">
      <span>{'language:'}</span>
      <LanguageOption
        value={getOptionsValue(options, 'language')}
        onChange={onOptionChange}
      />
    </li>
    <li className="line-row indent-1">
      <span>{'theme: {'}</span>
    </li>
    <li className="line-row indent-2">
      <span>{'logo:'}</span>
      <LogoOption
        value={getOptionsValue(options, 'logo')}
        onChange={onOptionChange}
        logos={logos}
      />
    </li>
    <li className="line-row indent-2">
      <span>{'primaryColor: '}</span>
      <ColorOption
        value={getOptionsValue(options, 'primaryColor')}
        onChange={onOptionChange}
        defaultColor={defaultColor}
      />
    </li>
    <li className="line-row indent-1">
      <span>{'}'}</span>
    </li>
    <li className="line-row">
      <span>{'});'}</span>
    </li>
    <li className="line-row">
      <span>{'lock.show();'}</span>
    </li>
  </ol>;

EditorWeb.propTypes = {
  onOptionChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  logos: PropTypes.array,
  defaultColor: PropTypes.string
};

export default EditorWeb;



// WEBPACK FOOTER //
// ./src/components/Editor/EditorWeb.js


// WEBPACK FOOTER //
// webpack:///src/components/Editor/EditorWeb.js